import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { entityHistoryApi } from '@/api/entityHistory'
import { useTenantKey } from './useTenantKey'
import type { EntityHistoryEntityType } from '@/types'

export const ENTITY_HISTORY_PAGE_SIZE = 50

export function useEntityHistory(
  projectId: string,
  entityType: EntityHistoryEntityType,
  entityId: string,
  maxResultCount: number = ENTITY_HISTORY_PAGE_SIZE,
) {
  const tenantKey = useTenantKey()

  return useQuery({
    queryKey: tenantKey('projects', projectId, 'history', entityType, entityId, maxResultCount),
    queryFn: () => entityHistoryApi.getAll(projectId, entityType, entityId, { maxResultCount, skipCount: 0 }),
    enabled: !!projectId && !!entityId,
    placeholderData: keepPreviousData,
    // History also grows from writes this client never makes — workflow nodes and agent tools edit
    // work items server-side — so it cannot rely on mutation invalidation alone to stay current.
    staleTime: 0,
  })
}
